import * as Yup from 'yup';
//utils
import {emailSchema, passwordSchema} from '@/utils/validation';

export type CreateTeamMemberFormValues = {
	firstName: string;
	lastName: string;
	userName: string;
	password: string;
	role: string;
	emailForPassword: string;
};

export const initialValues: CreateTeamMemberFormValues = {
	firstName: '',
	lastName: '',
	userName: '',
	password: '',
	role: '',
	emailForPassword: '',
};

export const validationSchema = Yup.object().shape({
	firstName: Yup.string().trim().required('First name is required'),
	lastName: Yup.string().trim().required('Last Name name is required'),
	userName: Yup.string().trim().required('User name name is required'),
	emailForPassword: emailSchema,
	password: passwordSchema,
	role: Yup.string().required('Role is required'),
});
